import { Controller, ControlProps } from '../types';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface VisibilityControlProps extends ControlProps {}

interface VisibilityHandlers {
  hide: (name: string) => void;
  show: (name: string) => void;
  isVisible: (name: string) => boolean;
}

export const VisibilityControllerId = 'VISIBILITY';

export interface VisibilityController extends Controller<VisibilityHandlers> {
  id: typeof VisibilityControllerId;
}
